import { ServerConfig } from "@/config/config";
import { Job } from "@/models/job";
import { Axios } from "@/utils/axios";

export interface IYukiSaleSyncStatus {
	ID: number;
	WinfaktSaleID: number;
	Processed: boolean;
	Status: string;
	LastError: string;
	Attempts: number;
	LastSyncedAt: string;
}

export interface IYukiPurchaseSyncStatus {
	ID: number;
	WinfaktPurchaseID: number;
	BookYear: number;
	YukiDocumentID: string;
	Status: string;
	LastError: string;
	Attempts: number;
	LastSyncedAt: string;
}

export interface IYukiPurchaseRef {
	ID:number;
	BookYear:number;
}

export interface IExportToYukiOptions {
	bookYear?:number;
	beginDate?:Date;
	endDate?:Date;
	journalIds?:number[];
	saleIds?:number[];
	purchases?:IYukiPurchaseRef[];
	includeAlreadySynced?:boolean;
}

export interface IYukiExportError {
	FriendlyID:string;
	Error:string;
}

export interface IYukiExportResult {
	Created:number;
	Skipped:number;
	Failed:number;
	Errors:IYukiExportError[];
	Canceled:boolean;
}

export class YukiSyncServiceClass {
	private readonly baseUrl:string = `${ServerConfig.host}/yuki`;

	async pushSale(saleId:number):Promise<{Reference:string, Processed:boolean, AttachmentError?:string}>{
		let result = await Axios.post(`${this.baseUrl}/push-sale/${saleId}`);
		return result.data;
	}

	async getSaleSync(saleId:number):Promise<IYukiSaleSyncStatus | null>{
		let result = await Axios.get(`${this.baseUrl}/sale-sync/${saleId}`);
		return result.data || null;
	}

	async pushPurchase(purchaseId:number, bookYear:number):Promise<{YukiDocumentID:string}>{
		let result = await Axios.post(`${this.baseUrl}/push-purchase/${purchaseId}?bookYear=${bookYear}`);
		return result.data;
	}

	async getPurchaseSync(purchaseId:number, bookYear:number):Promise<IYukiPurchaseSyncStatus | null>{
		let result = await Axios.get(`${this.baseUrl}/purchase-sync/${purchaseId}?bookYear=${bookYear}`);
		return result.data || null;
	}

	async exportPurchasePeriod(options:IExportToYukiOptions = {}):Promise<Job>{
		let body = {
			bookYear: options.bookYear || 0,
			beginDate: options.beginDate,
			endDate: options.endDate,
			journalIds: options.journalIds || [],
			purchases: options.purchases || [],
			includeAlreadySynced: options.includeAlreadySynced || false
		};
		let result = await Axios.post(`${this.baseUrl}/export-purchases`, body);
		return new Job(result.data);
	}

	async exportPeriod(options:IExportToYukiOptions = {}):Promise<Job>{
		let body = {
			bookYear: options.bookYear || 0,
			beginDate: options.beginDate,
			endDate: options.endDate,
			journalIds: options.journalIds || [],
			saleIds: options.saleIds || [],
			includeAlreadySynced: options.includeAlreadySynced || false
		};
		let result = await Axios.post(`${this.baseUrl}/export-period`, body);
		return new Job(result.data);
	}
}

export const YukiSyncService = new YukiSyncServiceClass();
